import React, { Component } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PaymentOptions from '../PaymentOptions';
import PaymentButton from '../PaymentButton';
import DatePickerOrder from '../DatePickerOrder';
import OptionsForOrder from '../../DefaultMenu/OptionsForOrder';
import currencyUtils from 'utils/currency';
import timeUtils from 'utils/time';
import objectUtils from 'utils/object';
import * as actions from 'actions/index';
import '../Cart.css';
import Aux from 'hoc/ReactAux/ReactAux';
import moment from 'moment';
import ModalConfirm from 'components/UI/Modal/ModalConfirm';
import ModalError from 'components/UI/Modal/ModalError';
import ModalCartMessage from 'components/UI/Modal/ModalCartMessage';
import Spinner from '../../../../components/UI/Spinner/Spinner';
import {
  cartTotalText,
  checkoutRefusal,
  guestDisplayName,
  guestFieldsForGuest,
  guestNamesRefusal,
  partyHeaderName,
  splitBasket,
} from '../../../../config/guestOrdering';
import { overlaySupportContext } from '../../../../support/context';
import { ERROR_CODES, errorCopy } from '../../../../utils/userError';
import {
  notifyVoiceOrder,
  registerVoiceOrderHandler,
} from '../../../../support/voiceOrder';
import AllergenGate from '../../../../support/AllergenGate';
import {
  allergenGateApplies,
  cartLines,
  getAllergyRevision,
  runBasketCheck,
  setAllergyAnswer,
} from '../../../../support/basketCheck';

const basketKey = products => JSON.stringify(cartLines(products));

const RESTAURANT_GONE_ERROR = errorCopy(ERROR_CODES.MENU_RESTAURANT_UNAVAILABLE, {
  title: "This restaurant isn't taking orders now",
  message: 'It stopped taking orders while your basket was open.',
  guidance: 'Reload the menu to choose again. Your basket will be emptied.',
});

// A key that changes when the basket's split into people changes.
const partySignature = parties =>
  parties.map(party => `${party.guestId}:${party.subtotal}`).join('|');

export class CartProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cutlery: false,
      timeForOrder: null,
      payOption: '',
      cardSelected: '',
      payType: null,
      payWithAnotherCard: false,
      currencySimbol: '€',
      currency: 'EUR',
      specialNotes: '',
      discounts: {},
      showDeliveryTomorrowConfirmationModal: false,
      deliveryDateOnly: null,
      selectAddress: false,
      openModalClearBasket: false,
      totalTip: 0,
      tipCustom: 0,
      tipValue: 0,
      sendingOrders: false,
      placingOrder: false,
    };
  }

  componentDidMount() {
    this.unregisterVoiceCheckout = registerVoiceOrderHandler('checkout', this.voiceCheckout);
    this.unregisterVoiceSummary = registerVoiceOrderHandler('summary', this.voiceOrderSummary);
    if (this.props.checkout) this.showBasketSupportContext();
    this.props.onFetchGuestPolicy();
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.unregisterVoiceCheckout) this.unregisterVoiceCheckout();
    if (this.unregisterVoiceSummary) this.unregisterVoiceSummary();
    if (this.restoreSupportContext) this.restoreSupportContext();
  }

  // The basket is always mounted; it is the support context only while it is open.
  showBasketSupportContext() {
    if (this.restoreSupportContext) this.restoreSupportContext();
    this.restoreSupportContext = overlaySupportContext('checkout.cart', {
      restaurantId: this.props.restaurantSelected && this.props.restaurantSelected.id,
    });
  }

  componentDidUpdate(prevProps) {
    const restaurantId = r => (r ? r.id : null);
    if (restaurantId(prevProps.restaurantSelected) !== restaurantId(this.props.restaurantSelected)) {
      // Any allergen check still out was for the other restaurant: it can never authorise this one.
      this.gateSeq = (this.gateSeq || 0) + 1;
      if (this.state.allergenQuote || this.state.allergenGate)
        this.setState({ allergenQuote: null, allergenSeenText: null, allergenGate: null });
    }
    if (
      prevProps.total !== this.props.total ||
      prevProps.productsOnCart !== this.props.productsOnCart ||
      prevProps.business !== this.props.business
    )
      notifyVoiceOrder();
    // A card payment runs after the order request settles; keep the overlay until it ends.
    if (this.state.placingOrder && this.orderRequestSettled && !this.props.isLoading) {
      this.setState({ placingOrder: false });
    }
    // The guest policy is re-read whenever the basket opens.
    if (this.props.checkout && !prevProps.checkout) {
      this.props.onFetchGuestPolicy();
      this.showBasketSupportContext();
    }
    if (!this.props.checkout && prevProps.checkout && this.restoreSupportContext) {
      this.restoreSupportContext();
      this.restoreSupportContext = null;
    }
    this.handleCampaignRate(prevProps);
    const partiesChanged =
      partySignature(splitBasket(prevProps.productsOnCart, prevProps.guests)) !==
      partySignature(this.getParties());
    if (
      prevProps.productsOnCart.length !== this.props.productsOnCart.length ||
      this.props.campaignRateCollection !== prevProps.campaignRateCollection ||
      partiesChanged
    )
      this.handleCalculateValuesCart(partiesChanged);
    if (
      this.props.restaurantSelected &&
      JSON.stringify(this.props.restaurantSelected) !==
        JSON.stringify(prevProps.restaurantSelected)
    ) {
      let currency = this.props.restaurantSelected.currency;
      let currencySimbol = currencyUtils.convertNameToSymbol(currency);

      localStorage.setItem('currency', currency);
      this.setState({
        specialNotes: '',
        timeForOrder: null,
        cardSelected: null,
        payType: null,
        currency: currency,
        currencySimbol: currencySimbol,
        isSpinnerVisible: false,
      });
    }
  }
  handleConfirmOkCartModal = () => {
    this.setState({ openModalClearBasket: false });
    this.setState({ selectAddress: true });
    this.props.onDeleteAllproductsFromCard();
  };

  handleDenyCartModal = () => {
    this.setState({ openModalClearBasket: false });
  };

  handleCampaignRate = prevProps => {
    if (
      this.props.restaurantSelected &&
      JSON.stringify(this.props.restaurantSelected) !==
        JSON.stringify(prevProps.restaurantSelected)
    ) {
      this.props.onFetchingCampaignRate(this.props.restaurantSelected.id);
    }
  };

  // The basket's + adds another of the same item for the same person, without asking.
  handleIncreaseQuantityProduct = product => {
    this.props.onAddProductToCartNow({
      product: product,
      business: this.props.restaurantSelected,
    });
  };

  handleDecreaseProduct = product => {
    this.props.onDeleteProductFromCart({
      product: product,
    });
  };

  onHandleSelectPaymentMethod = (id, type) => {
    switch (type) {
      case 'ideal':
        this.setState({
          payOption: 'ideal',
          payType: 'I',
          payWithAnotherCard: true,
        });
        break;
      case 'bancontact':
        this.setState({
          payOption: 'bancontact',
          payType: 'B',
          payWithAnotherCard: true,
        });
        break;
      case 'onAccount':
        this.setState({ payOption: 'onAccount', payType: 'A' });
        break;
      case 'onCreditCard':
        if (id === 'payWithAnotherCard') {
          this.setState({
            payOption: 'onCreditCard',
            payType: 'C',
            cardSelected: null,
            payWithAnotherCard: true,
          });
        } else {
          let card = this.props.cards.find(item => {
            return item.cardId === id;
          });
          this.setState({
            payOption: 'onCreditCard',
            payType: 'C',
            cardSelected: card,
            payWithAnotherCard: false,
          });
        }
        break;
      case 'onVoucher':
        this.setState({ payOption: 'onVoucher', payType: 'A' });
        break;
      default:
        break;
    }
  };

  onHandleAddCutlery = event => {
    this.setState({ cutlery: event.target.checked });
  };

  handleSpecialNotes = event => {
    this.setState({ specialNotes: event.target.value });
  };

  // One group per person: you first (when you have items), then guests in the order added.
  getParties = () => splitBasket(this.props.productsOnCart, this.props.guests);

  // calculate-discount's answer for one person's order, once it has arrived.
  getPartyValue = guestId =>
    (this.props.partyValues || []).find(value => value.guestId === guestId) || null;

  // The header total for one person: their order total, plus the tip on the first order.
  getPartyTotal = (party, index) => {
    const value = this.getPartyValue(party.guestId);
    const total = value ? value.total : party.subtotal;
    return total + (index === 0 ? this.getTotalTip() : 0);
  };

  onDeliveryTomorrow = ({ target }) => {
    this.props.changeDeliveryTomorrow(target.checked);
    if (target.checked) {
      this.setState({
        deliveryDateOnly: moment()
          .add(1, 'day')
          .format('DD/MM/YYYY'),
      });
    } else {
      this.setState({ deliveryDateOnly: moment().format('DD/MM/YYYY') });
    }
  };

  handleDeliveryTomorrow = () => {
    if (this.isBasketEmpty()) return;
    this.setState({ isSpinnerVisible: true });
    if (this.props.deliveryTomorrow) {
      this.setState({ showDeliveryTomorrowConfirmationModal: true });
    } else {
      this.onHandlePlaceOrder();
    }
  };

  handleDeliveryTomorrowCancel = () => {
    this.setState({ showDeliveryTomorrowConfirmationModal: false });
  };

  handleDeliveryTomorrowConfirm = () => {
    this.setState({ showDeliveryTomorrowConfirmationModal: false });
    this.onHandlePlaceOrder();
  };

  // On a pilot restaurant every Place Order passes the allergen gate: the server checks the live menu and the
  // basket, and the order goes only when that check is confirmable for the quote the customer confirmed. Anything
  // else (a change, an unanswered question, a dish that needs the restaurant) opens the gate instead. A failed
  // check never falls back to the basket as it was.
  onHandlePlaceOrder = () => {
    if (this.isBasketEmpty()) return undefined;
    const restaurant = this.props.restaurantSelected;
    if (!restaurant || !allergenGateApplies(restaurant.id)) return this.placeOrderNow();
    // One final check at a time: a second press while one runs places nothing (Codex r2: no double placement).
    if (this.finalCheckInFlight) return undefined;
    this.finalCheckInFlight = true;
    const quoteHash = this.state.allergenQuote || undefined;
    const seenAdviceText = this.state.allergenSeenText || undefined;
    this.setState({ allergenQuote: null, allergenBusy: true, allergenError: '' });
    // The check is bound to this restaurant, this basket and this allergy answer; each placement path checks the
    // binding again just before it sends anything (Codex r2).
    const token = this.gateToken(restaurant.id);
    const release = () => {
      this.finalCheckInFlight = false;
    };
    return runBasketCheck({
      restaurantId: restaurant.id,
      products: this.props.productsOnCart,
      quoteHash,
      seenAdviceText,
    }).then(
      check => {
        if (this.unmounted) return release();
        if (!check || check.applies !== true) {
          release();
          // A pilot restaurant without an answer from the allergen check is never placed (fail closed).
          this.setState({
            allergenBusy: false,
            isSpinnerVisible: false,
            allergenGate: { applies: true, blockers: ['CHECK_FAILED'] },
            allergenError:
              "We couldn't check allergens for this restaurant just now, so your order wasn't placed. Please try again.",
          });
          return undefined;
        }
        if (!this.gateRestaurantStill(token)) {
          release();
          this.setState({
            allergenBusy: false,
            isSpinnerVisible: false,
            allergenSeenText: null,
            allergenGate: null,
            allergenError: 'The restaurant changed while we checked your order, so it wasn\'t placed.',
          });
          return undefined;
        }
        if (basketKey(this.props.productsOnCart) !== token.lines) {
          release();
          this.setState({
            allergenBusy: false,
            isSpinnerVisible: false,
            allergenError: 'Your basket changed while we checked it. Please read the allergen information again.',
          });
          this.refreshAllergenGate();
          return undefined;
        }
        if (getAllergyRevision(restaurant.id) !== token.revision) {
          release();
          // Codex retest 8 P1: the answer moved after this check started (a milk allergy added to "none"). The old
          // quote and acknowledgement are void; a fresh check of the new answer needs fresh advice and a fresh tick.
          this.setState({
            allergenBusy: false,
            isSpinnerVisible: false,
            allergenQuote: null,
            allergenSeenText: null,
            allergenError:
              'Your allergy answer changed while we checked your order, so it wasn\'t placed. Please read the allergen information again.',
          });
          this.refreshAllergenGate();
          return undefined;
        }
        if (check.confirmable) {
          this.setState({ allergenBusy: false, allergenGate: null, allergenSeenText: null });
          const placing = this.placeOrderNow(token);
          // Released only once the placement settles, so a second confirmation can't start another one meanwhile.
          Promise.resolve(placing).then(release, release);
          return placing;
        }
        release();
        this.setState({ allergenBusy: false, allergenGate: check, isSpinnerVisible: false });
        return undefined;
      },
      error => {
        release();
        if (this.unmounted) return undefined;
        this.setState({
          allergenBusy: false,
          isSpinnerVisible: false,
          allergenGate: this.state.allergenGate || { applies: true, blockers: ['CHECK_FAILED'] },
          allergenError:
            (error && error.message) ||
            "We couldn't check the menu just now, so your order wasn't placed. Please try again.",
        });
        return undefined;
      }
    );
  };

  // What a final allergen check was for: restaurant, basket lines and allergy-answer revision, plus a sequence that
  // a restaurant change bumps so no outstanding check can authorise another restaurant.
  gateToken = restaurantId => ({
    seq: this.gateSeq || 0,
    restaurantId,
    lines: basketKey(this.props.productsOnCart),
    revision: getAllergyRevision(restaurantId),
  });

  gateRestaurantStill = token => {
    const restaurant = this.props.restaurantSelected;
    return !!token && !!restaurant && restaurant.id === token.restaurantId && (this.gateSeq || 0) === token.seq;
  };

  // null while the check still holds; otherwise the reason nothing may be placed.
  gateBroken = token => {
    if (!token) return null;
    if (!this.gateRestaurantStill(token)) return "The restaurant changed while we checked your order, so it wasn't placed.";
    if (basketKey(this.props.productsOnCart) !== token.lines)
      return 'Your basket changed while we checked it. Please read the allergen information again.';
    if (getAllergyRevision(token.restaurantId) !== token.revision)
      return "Your allergy answer changed while we checked your order, so it wasn't placed. Please read the allergen information again.";
    return null;
  };

  // A placement path found the check no longer holds: nothing is sent, the gate is checked again.
  refuseStaleGate = reason => {
    this.setState({
      allergenBusy: false,
      isSpinnerVisible: false,
      sendingOrders: false,
      allergenQuote: null,
      allergenSeenText: null,
      allergenError: reason,
    });
    this.refreshAllergenGate();
  };

  // The gate's own check after an answer, without placing anything.
  refreshAllergenGate = () => {
    const restaurant = this.props.restaurantSelected;
    if (!restaurant) return;
    this.setState({ allergenBusy: true });
    runBasketCheck({ restaurantId: restaurant.id, products: this.props.productsOnCart }).then(
      check => {
        if (!this.unmounted) this.setState({ allergenBusy: false, allergenGate: check });
      },
      error => {
        if (!this.unmounted)
          this.setState({
            allergenBusy: false,
            allergenError: (error && error.message) || "We couldn't check the menu just now.",
          });
      }
    );
  };

  onAllergenAnswer = answer => {
    const restaurant = this.props.restaurantSelected;
    if (!restaurant) return;
    this.setState({ allergenError: '' });
    setAllergyAnswer(restaurant.id, answer);
    this.refreshAllergenGate();
  };

  // "I have read this. Confirm order": the customer confirms this exact quote; the server checks it once more.
  onAllergenConfirm = () => {
    const check = this.state.allergenGate;
    if (!check || !check.quoteHash) return;
    this.setState(
      {
        allergenQuote: check.quoteHash,
        allergenSeenText: check.advice && check.advice.text,
      },
      () => this.onHandlePlaceOrder()
    );
  };

  onAllergenClose = () => {
    this.setState({ allergenGate: null, allergenQuote: null, allergenError: '', isSpinnerVisible: false });
  };

  placeOrderNow = gate => {
    // An empty basket is never sent, whatever the payment choice.
    if (this.isBasketEmpty()) return undefined;
    // On a pilot restaurant the allergen check must still hold for this restaurant, basket and answer (Codex r2).
    const broken = this.gateBroken(gate);
    if (broken) {
      this.refuseStaleGate(broken);
      return undefined;
    }
    if (
      this.props.restaurantSelected &&
      !this.props.restaurantSelected.isOpen
    ) {
      this.props.triggerModalErrorPlacedOrder({
        code: ERROR_CODES.ORDER_CUTOFF_PASSED,
        title: "We couldn't place your order",
        message: `${this.props.restaurantSelected.name} has stopped taking orders for today.`,
        guidance: 'Choose another restaurant, or order for tomorrow.',
      });
    } else if (
      this.props.restaurantSelected &&
      (this.props.restaurantSelected.platter ||
        this.props.restaurantSelected.forCollection === 'Y') &&
      !!!this.state.timeForOrder
    ) {
      const what = this.props.restaurantSelected.platter ? 'delivery' : 'collection';
      this.props.triggerModalErrorPlacedOrder({
        code: ERROR_CODES.ORDER_TIME_MISSING,
        title: `Choose a ${what} time`,
        message: `This restaurant needs a ${what} time for every order.`,
        guidance: `Pick a ${what} time in the basket, then place your order.`,
      });
    } else if (
      this.state.payOption === 'onAccount' &&
      !!this.props.business.valueLimit &&
      this.largestOrderTotal() > this.props.business.valueLimit
    ) {
      this.props.triggerModalErrorPlacedOrder({
        code: ERROR_CODES.ORDER_MAX_EXCEEDED,
        title: "This order is over your company's limit",
        message:
          'Your company limits On account orders to ' +
          this.state.currencySimbol +
          this.props.business.valueLimit.toFixed(2) +
          ' per order.',
        guidance: 'Remove some items, or pay for this order by card.',
      });
    } else if (this.guestCheckoutRefusal()) {
      this.props.triggerModalErrorPlacedOrder({
        code: ERROR_CODES.ORDER_GUEST_NOT_ALLOWED,
        title: "We can't place this order yet",
        message: this.guestCheckoutRefusal(),
        guidance: 'Change the basket, then place your order.',
      });
    } else if (this.props.restaurantSelected && this.getParties().length > 1) {
      return this.placeOrdersForParties(gate);
    } else if (this.props.restaurantSelected) {
      // One person: the existing flow, so a new card still works. For a guest, the
      // order carries their name and key.
      const parties = this.getParties();
      let order = this.buildingOrder({
        guest: parties.length === 1 ? parties[0].guest : null,
      });
      let placing;
      if (this.state.payType === 'C' && !this.state.payWithAnotherCard) {
        placing = this.handlePlaceOrderAndPay(order);
      } else if (
        (this.state.payType === 'C' && !!this.state.payWithAnotherCard) ||
        this.state.payType === 'I' ||
        this.state.payType === 'B'
      ) {
        placing = this.props.handlePlaceOrderAndGoToAddNewCard(
          order,
          this.getPayInfo(),
          this.props.history
        );
      } else {
        placing = this.props.onPlaceOrder(order, this.getPayInfo());
      }
      this.trackPlacing(placing);
      return placing;
    }
    return undefined;
  };

  // Voice ordering: why this basket can't be placed On Account from the composer, or null. Anything that
  // needs a choice on the basket (a time, tomorrow, guests, the company's limit) is done there instead.
  voiceCheckoutRefusal = () => {
    const restaurant = this.props.restaurantSelected;
    const business = this.props.business;
    if (!restaurant || !this.props.productsOnCart || !this.props.productsOnCart.length)
      return 'Your basket is empty.';
    if (!business || business.acceptOnAccount !== 'Y' || this.props.onlyCreditCard)
      return "Your company doesn't take On Account orders here. Open the basket to pay.";
    if (!restaurant.isOpen) return `Sorry, ${restaurant.name} is closed now.`;
    if (restaurant.platter || restaurant.forCollection === 'Y')
      return 'Open the basket to choose a time for this order.';
    if (this.props.deliveryTomorrow) return "Open the basket to confirm tomorrow's delivery.";
    if (this.getParties().length > 1)
      return 'Your basket has orders for guests. Open the basket to place them.';
    if (!!business.valueLimit && this.largestOrderTotal() > business.valueLimit)
      return `Your company limits orders to ${this.state.currencySimbol}${business.valueLimit.toFixed(
        2
      )}. Open the basket to change it.`;
    return null;
  };

  voiceOrderSummary = () => ({
    total: this.getTotal(),
    currencySymbol: this.state.currencySimbol,
    refusal: this.voiceCheckoutRefusal(),
    restaurantId: this.props.restaurantSelected && this.props.restaurantSelected.id,
    products: this.props.productsOnCart || [],
  });

  // Voice ordering's MEDIUM-risk action, run only after the customer taps "Place order On Account" in the
  // composer: On Account, then exactly the basket's own Place Order. Never a card.
  // On a pilot restaurant the composer passes the quote the customer confirmed (and heard), which the gate checks
  // once more on the server before the order is placed.
  voiceCheckout = ({ quoteHash, adviceText } = {}) => {
    const refusal = this.voiceCheckoutRefusal();
    if (refusal) return Promise.resolve({ placed: false, reason: refusal });
    return new Promise(resolve => {
      this.setState({
        payOption: 'onAccount',
        payType: 'A',
        payWithAnotherCard: false,
        allergenQuote: quoteHash || null,
        allergenSeenText: adviceText || null,
      }, () => {
        if (this.state.payType !== 'A') {
          resolve({ placed: false, reason: 'Open the basket to place your order.' });
          return;
        }
        const placing = this.onHandlePlaceOrder();
        if (!placing) {
          resolve({
            placed: false,
            reason: this.state.allergenGate
              ? 'Something changed before your order was placed. Check the basket and confirm again.'
              : 'Your order was not placed. Open the basket to see why.',
          });
          return;
        }
        Promise.resolve(placing).then(
          data =>
            resolve(
              data && data.id
                ? { placed: true, orderId: data.id, publicOrderNumber: data.publicOrderNumber }
                : {
                    placed: false,
                    reason: this.state.allergenGate
                      ? 'Something changed before your order was placed. Check the basket and confirm again.'
                      : 'Your order was not placed. Open the basket to try again.',
                  }
            ),
          () => resolve({ placed: false, reason: 'Your order was not placed. Open the basket to try again.' })
        );
      });
    });
  };

  getAddressForOrder = () => {
    if (this.props.restaurantSelected.forCollection === 'Y') {
      return this.props.addresses.find(item => item.forCollection)
        .idBusinessAddress;
    } else {
      return this.props.addresses.find(item => !item.forCollection)
        .idBusinessAddress;
    }
  };

  getCustomerAddressForOrder = () => {
    return this.props.addresses.find(item => !item.forCollection)
      .idCustomerDeliveryAddress;
  };

  // Checked before anything is sent: every guest's name, then the payment rules.
  guestCheckoutRefusal = () => {
    const parties = this.getParties();
    const guests = parties.filter(party => !!party.guest).map(party => party.guest);
    return (
      guestNamesRefusal(guests) ||
      checkoutRefusal({
        partyCount: parties.length,
        hasGuest: guests.length > 0,
        payType: this.state.payType,
        payWithAnotherCard: this.state.payWithAnotherCard,
        policy: this.props.guestPolicy,
      })
    );
  };

  // The per-order value limit applies to each person's order.
  largestOrderTotal = () => {
    const parties = this.getParties();
    if (parties.length < 2) return this.props.total;
    return Math.max.apply(
      null,
      parties.map(party => {
        const value = this.getPartyValue(party.guestId);
        return value ? value.total : party.subtotal;
      })
    );
  };

  // Several people: one order each, sent one after another (you first, then guests
  // in the order they were added). The subsidy is asked for again per order first.
  placeOrdersForParties = gate => {
    const parties = this.getParties();
    const restaurant = this.props.restaurantSelected;
    const withSubsidy =
      restaurant.forCollection === 'N' && this.props.restaurantCurrentIsOpen;
    const taxDelivery =
      restaurant.taxDelivery && this.isDeliverAtHome() ? restaurant.taxDelivery : 0;
    const tipValue = this.getTotalTip();
    const surcharge =
      this.state.payType === 'C' && !!this.props.campaignRateCC
        ? this.props.campaignRateCC.amount
        : 0;

    this.setState({ sendingOrders: true });
    return Promise.resolve(
      this.props.onCalculatePartySubsidies(
        restaurant.id,
        parties,
        taxDelivery,
        tipValue,
        withSubsidy
      )
    )
      .then(values => {
        // The subsidy answer can come back after the allergy answer, the basket or the restaurant changed: on a pilot
        // restaurant nothing is sent unless the allergen check still holds right now (Codex r2 P1).
        const broken = this.unmounted ? 'gone' : this.gateBroken(gate);
        if (broken) {
          if (!this.unmounted) this.refuseStaleGate(broken);
          return undefined;
        }
        const sends = parties.map((party, index) => {
          const value =
            (values || []).find(item => item.guestId === party.guestId) ||
            this.getPartyValue(party.guestId) || {
              total: party.subtotal,
              discounts: this.props.discounts,
            };
          // The tip goes on the first order: yours, or the first guest's.
          const tip = index === 0 ? tipValue : 0;
          return {
            guestId: party.guestId,
            name: party.guest ? guestDisplayName(party.guest) : 'you',
            order: this.buildingOrder({
              products: party.products,
              totalAmount: value.total,
              tipValue: tip,
              guest: party.guest,
            }),
            payInfo: {
              ...this.getPayInfo(),
              amount: value.total + surcharge,
              tipValue: tip,
              discounts: value.discounts,
            },
          };
        });
        // Each guest order is checked again right before it is sent (Codex r3 P1): a change while an earlier order or
        // payment waits stops the rest.
        return this.props.onPlacePartyOrders(sends, gate ? { stillValid: () => this.gateBroken(gate) } : undefined);
      })
      .then(
        () => !this.unmounted && this.setState({ sendingOrders: false }),
        () => !this.unmounted && this.setState({ sendingOrders: false })
      );
  };

  getOrderItems = (products = this.props.productsOnCart) => {
    return products.map(product => {
      if (product.mealOptions) {
        let mealOptions = product.mealOptions.map(mealOption => {
          return {
            idProduct: mealOption.idProduct || mealOption.idMealOption,
            idCategoryType: mealOption.idCategoryType,
          };
        });
        return {
          quantity: 1,
          specialNotes: product.specialInstructions,
          product: { id: product.id },
          total: product.price,
          mealOptions: mealOptions,
        };
      } else {
        return {
          quantity: 1,
          product: { id: product.id },
          total: product.price,
        };
      }
    });
  };

  // The order for the whole basket, or for one person's items. The guest id stays
  // here: only the guest's name and request key go to the server.
  buildingOrder = ({
    products = this.props.productsOnCart,
    totalAmount = this.props.total,
    tipValue = this.getTotalTip(),
    guest = null,
  } = {}) => {
    let orderItems = this.getOrderItems(products);

    let specialNotes = this.state.cutlery
      ? this.state.specialNotes + '. Please add cutlery'
      : this.state.specialNotes;

    let order = {
      totalAmount: totalAmount,
      specialNotes: specialNotes,
      tipValue: tipValue,
      restaurant: { id: this.props.restaurantSelected.id },
      orderItems: orderItems,
      businessDeliveryAddress: { id: this.getAddressForOrder() },
      customerDeliveryAddress: { id: this.getCustomerAddressForOrder() },
      payType: this.state.payType,

      deliveryDateOnly: this.props.deliveryTomorrow
        ? this.state.deliveryDateOnly
        : null,
      ...guestFieldsForGuest(guest),
    };

    const isDeliverAtHome =
      this.getDeliverAddress() != null
        ? this.getDeliverAddress().idCustomerDeliveryAddress != null
        : false;

    if (
      this.props.restaurantSelected.forCollection === 'Y' ||
      this.props.restaurantSelected.platter ||
      isDeliverAtHome
    ) {
      let deliveryDate;
      if (this.state.timeForOrder == null) {
        // 01:00 PM
        deliveryDate =
          timeUtils.getCurrentDate() +
          ' ' +
          timeUtils.millisecondsToTime(46800);
      } else if (this.state.timeForOrder._isAMomentObject) {
        deliveryDate = this.state.timeForOrder.format('DD/MM/YYYY HH:mm');
      } else {
        deliveryDate =
          timeUtils.getCurrentDate() +
          ' ' +
          timeUtils.millisecondsToTime(this.state.timeForOrder);
      }
      order = {
        ...order,
        deliveryDate: deliveryDate,
        deliverAtHome: isDeliverAtHome,
      };
    }

    return order;
  };

  isPayTypeEqualToCreditCard = () => {
    return this.state.payType === 'C';
  };

  getAmountPayInfo = () => {
    let amount = this.props.total;
    amount +=
      this.state.payType === 'C' && !!this.props.campaignRateCC
        ? this.props.campaignRateCC.amount
        : 0;
    return amount;
  };

  getPayInfo = () => {
    return {
      amount: this.getAmountPayInfo(),
      currency: this.state.currency,
      payType: this.state.payType,
      paymentReference: objectUtils.get(
        this.state,
        'cardSelected.cardId',
        undefined
      ),
      tipValue: this.getTotalTip(),
      idBusinessRestaurant: objectUtils.get(
        this.props,
        'restaurantSelected.id',
        undefined
      ),
      payObjectType: 'O',
      discounts: this.props.discounts,
    };
  };

  // "Placing your order" shows only while an order request is in flight, not for any
  // other request (e.g. the lunch feedback card), which also sets the global loading flag.
  trackPlacing = placing => {
    this.orderRequestSettled = false;
    this.setState({ placingOrder: true });
    const done = () => {
      this.orderRequestSettled = true;
      if (!this.unmounted && !this.props.isLoading) this.setState({ placingOrder: false });
    };
    Promise.resolve(placing).then(done, done);
  };

  handlePlaceOrderAndPay = order => {
    return this.props.onPlaceOrderAndPay(order, this.getPayInfo());
  };

  handleTimeForOrder = date => {
    this.setState({ timeForOrder: date });
  };

  getTaxDelivery = () => {
    return !!this.props.restaurantSelected &&
      this.props.restaurantSelected.taxDelivery &&
      this.isDeliverAtHome()
      ? this.props.restaurantSelected.taxDelivery.toFixed(2)
      : Number(0).toFixed(2);
  };

  getStyleInputTipCustom = () => {
    var number = this.state.totalTip;
    return number > 20
      ? 'tip-custom-amount-input-container'
      : 'tip-custom-amount-input-container-hidden';
  };

  getStyleButtonTipCustom = () => {
    var number = this.state.totalTip;
    return number > 20 ? 'tip-custom-selected' : 'tip-custom';
  };

  getStyleButtonTip = button => {
    var number = this.state.totalTip;
    return number === button ? 'tip-percent-selected' : 'tip-percent';
  };

  formatNumber(n) {
    return n.replace(/\D/g, '').replace(/(\d)(\d{2})$/, '$1.$2');
  }

  onClickTip = event => {
    switch (event.target.value) {
      case '0':
        if (this.state.totalTip === 0) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 0,
          });
        }

        break;
      case '5':
        if (this.state.totalTip === 5) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 5,
          });
        }

        break;

      case '10':
        if (this.state.totalTip === 10) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 10,
          });
        }

        break;

      case '20':
        if (this.state.totalTip === 20) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 20,
          });
        }

        break;

      default:
        if (this.state.totalTip === 21) {
          this.setState({
            totalTip: 0,
          });
        } else {
          this.setState({
            totalTip: 21,
          });
        }

        break;
    }
  };

  onChangeInputTip = event => {
    this.setState({
      tipCustom: this.formatNumber(event.target.value),
    });
  };

  verfifyNumber = number => {
    var numberFormated = number;

    if (number.length > 5) {
      numberFormated = number.replace('.', '');
      numberFormated = this.formatNumber(numberFormated);
    } else {
      return Number(number);
    }

    return numberFormated;
  };

  getTotalTip = () => {
    var tipValue =
      this.state.totalTip < 21
        ? Number.parseFloat(
            ((this.props.subtotal * this.state.totalTip) / 100).toPrecision(2)
          )
        : this.state.tipCustom === 0
        ? Number(this.state.tipCustom)
        : Number(this.verfifyNumber(this.state.tipCustom));

    return tipValue;
  };

  getTotal = () => {
    return this.getTotalTip() + this.props.total;
  };

  getMaxBasketCost = () => {
    if (!!this.props.maxBasketCost) {
      return `(for ${
        this.state.currencySimbol
      } ${this.props.maxBasketCost.toFixed(2)} max)`;
    }
    return '';
  };

  getDeliverAddress = () => {
    return this.props.addresses[0];
  };

  showOptionsForOrder = () => {
    this.setState({ openModalClearBasket: true });
  };

  showCollectionOption = () => {
    return (
      !this.props.addresses.find(address => address.forCollection) &&
      this.props.showCollectionOption
    );
  };

  toggleCart = () => {
    this.props.onToggleCart();
  };

  handleSelectOptionForOrder = address => {
    this.props.onSelectAddressForOrder([address]);
    this.setState({ selectAddress: false });
    this.props.restaurantSelected &&
      this.props.onCalculateSubsidy(
        this.props.restaurantSelected.id,
        0,
        this.props.restaurantSelected.taxDelivery && this.isDeliverAtHome()
          ? this.props.restaurantSelected.taxDelivery
          : 0,
        this.getTotalTip()
      );
  };

  closeModalErrorAndClearLocalStorageRestaurantCurrentIsOpen = () => {
    this.props.onCartSetRestaurantOpen(true);
    this.props.onDeleteAllproductsFromCard();
    window.location.reload();
  };

  handleCreateCustomerDeliveryAddress = async place => {
    await this.props.onCreateCustomerDeliveryAddress(place);
    this.setState({ selectAddress: false });
    this.props.onCalculateSubsidy(
      this.props.restaurantSelected.id,
      0,
      this.props.restaurantSelected.taxDelivery && this.isDeliverAtHome()
        ? this.props.restaurantSelected.taxDelivery
        : 0,
      this.getTotalTip()
    );
  };

  isDeliverAtHome = () => {
    return this.getDeliverAddress() != null
      ? this.getDeliverAddress().idCustomerDeliveryAddress != null
      : false;
  };

  handleCalculateValuesCart = (partiesChanged = false) => {
    let tipValue = this.getTotalTip();
    let subtotal = this.props.productsOnCart.reduce((a, product) => {
      return a + product.price;
    }, 0);
    const parties = this.getParties();

    // Several people: the subsidy is worked out per order.
    if (parties.length > 1) {
      if (!!this.props.campaignRateCollection && this.props.restaurantSelected) {
        this.props.onCalculatePartySubsidies(
          this.props.restaurantSelected.id,
          parties,
          this.props.restaurantSelected.taxDelivery && this.isDeliverAtHome()
            ? this.props.restaurantSelected.taxDelivery
            : 0,
          tipValue,
          this.props.restaurantSelected.forCollection === 'N' &&
            this.props.restaurantCurrentIsOpen
        );
      }
      return;
    }
    if ((this.props.partyValues || []).length > 0) {
      this.props.onClearPartyValues();
    }

    if (
      (!!this.props.campaignRateCollection &&
        (this.props.subtotal !== subtotal || partiesChanged)) ||
      (!!this.props.campaignRateCollection &&
        this.props.tipValue !== this.getTotalTip())
    ) {
      if (
        this.props.restaurantSelected.forCollection === 'N' &&
        this.props.restaurantCurrentIsOpen
      ) {
        this.props.onCalculateSubsidy(
          this.props.restaurantSelected.id,
          subtotal,
          this.props.restaurantSelected.taxDelivery && this.isDeliverAtHome()
            ? this.props.restaurantSelected.taxDelivery
            : 0,
          tipValue
        );
      } else {
        this.props.onAppliedCartValues(
          subtotal,
          0,
          subtotal,
          0,
          this.props.discounts,
          tipValue
        );
      }
    }
  };

  isWithVoucherOrNotAcceptTip = () => {
    const isVoucher =
      this.props.total === 0 &&
      this.props.subsidy > 0 &&
      !this.props.onlyCreditCard;
    const acceptTip =
      this.props.restaurantSelected !== null &&
      !this.props.restaurantSelected.acceptTip;

    return isVoucher || acceptTip;
  };

  renderItem = (product, index) => (
    <li key={index} className="item">
      <button
        onClick={() => this.handleDecreaseProduct(product)}
        className="remove-item"
        aria-label={`Remove ${product.name}`}
        aria-describedby={`product-desc-${index}`}
      />
      <div className="flex-center" tabIndex={0}>
        <button
          onClick={() => this.handleIncreaseQuantityProduct(product)}
          className="btn-add-product"
          aria-label="Increase quantity"
        />
        <h3 tabIndex={0}>
          {product.name}{' '}
          {this.state.currencySimbol + product.price.toFixed(2)}
        </h3>
      </div>
      <p
        tabIndex={0}
        className="product-cart-description"
        id={`product-desc-${index}`}
      >
        {product.description}
      </p>
    </li>
  );

  isBasketEmpty = () => !this.props.productsOnCart || this.props.productsOnCart.length === 0;

  // Nothing to order: no totals, payment choice or Place Order, just a way back to the restaurants.
  backToRestaurants = () => {
    this.props.onToggleCart(false);
    if (this.props.onToggleRestaurants) this.props.onToggleRestaurants(true);
  };

  renderEmptyBasket = () => (
    <Aux>
      <h2 tabIndex={0}>Your basket is empty</h2>
      <div className="items basket-empty" role="status">
        <p tabIndex={0}>Add something from a restaurant's menu to place an order.</p>
        <button type="button" className="btn orange-bold" onClick={this.backToRestaurants}>
          <b>Choose a restaurant</b>
        </button>
      </div>
    </Aux>
  );

  // Only your items: the basket looks exactly as before. With a guest: grouped by
  // person ("You", then each guest with a "Guest" tag), each with their order total.
  renderBasketItems = () => {
    const parties = this.getParties();
    const products = this.props.productsOnCart;
    if (!parties.some(party => !!party.guest)) {
      return (
        <ul className="items">
          {products.map((product, index) => this.renderItem(product, index))}
        </ul>
      );
    }
    return (
      <ul className="items">
        {parties.map((party, partyIndex) => (
          <li key={party.guestId || 'you'} className="basket-party">
            <div className="basket-party-header">
              <h3 tabIndex={0}>
                {partyHeaderName(party)}
                {party.guest ? (
                  <span className="basket-party-guest-tag">Guest</span>
                ) : null}
              </h3>
              <span className="basket-party-total" tabIndex={0}>
                {this.state.currencySimbol +
                  this.getPartyTotal(party, partyIndex).toFixed(2)}
              </span>
            </div>
            <ul>
              {party.products.map(product =>
                this.renderItem(product, products.indexOf(product))
              )}
            </ul>
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const orderCount = Math.max(1, this.getParties().length);
    const empty = this.isBasketEmpty();
    return (
      <Aux tabIndex={0}>
        <button
          title="Close (Esc)"
          type="button"
          className="btn-close"
          onClick={() => this.toggleCart()}
          aria-label="Close cart"
        />
        {empty ? (
          this.renderEmptyBasket()
        ) : (
          <Aux>
            <h2>Your Cart includes </h2>
            {this.renderBasketItems()}

            <div className="items" hidden={this.isWithVoucherOrNotAcceptTip()}>
              <p className="tip-title" tabIndex={0}>
                Tip the Driver (optional)
              </p>
              <div className="tip">
                <button
                  value="5"
                  className={this.getStyleButtonTip(5)}
                  onClick={this.onClickTip}
                >
                  5 %
                </button>
                <button
                  value="10"
                  className={this.getStyleButtonTip(10)}
                  onClick={this.onClickTip}
                >
                  10 %
                </button>
                <button
                  value="20"
                  className={this.getStyleButtonTip(20)}
                  onClick={this.onClickTip}
                >
                  20 %
                </button>
              </div>
              <div>
                <button
                  value="6"
                  className={this.getStyleButtonTipCustom()}
                  onClick={this.onClickTip}
                >
                  <b>Enter Custom Amount</b>
                </button>
                <div className={this.getStyleInputTipCustom()}>
                  <input
                    className="tip-custom-amount-input"
                    placeholder=" 0.00 "
                    value={
                      this.state.tipCustom === 0 ? undefined : this.state.tipCustom
                    }
                    onChange={this.onChangeInputTip}
                    data-type="currency"
                  />
                  <span className="sufix-tip-custom">
                    {this.state.currencySimbol + ' '}
                  </span>
                  <svg
                    className="icon-tip-custom"
                    aria-hidden="true"
                    focusable="false"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="9" cy="9" r="9" style={{ fill: "var(--lt-color-primary)" }} />
                    <path
                      d="M6 10.2594L8.25 11.8359L12 7.50035"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className="total-items">
              <div className="sub-total">
                <div className="left">
                  <p tabIndex={0}>Sub Total</p>
                </div>
                <div className="right">
                  <p tabIndex={0}>
                    {this.state.currencySimbol + this.props.subtotal.toFixed(2)}
                  </p>
                </div>
              </div>
              <div
                className="sub-total"
                hidden={this.isWithVoucherOrNotAcceptTip()}
              >
                <div className="left">
                  <p tabIndex={0}>Tip</p>
                </div>
                <div className="right">
                  <p tabIndex={0}>
                    {this.state.currencySimbol + this.getTotalTip().toFixed(2)}
                  </p>
                </div>
              </div>
              {this.props.restaurantSelected &&
                this.props.restaurantSelected.forCollection === 'N' && (
                  <div className="subsidy">
                    <div className="left">
                      <p tabIndex={0}>Subsidy {this.getMaxBasketCost()}</p>
                    </div>
                    <div className="right">
                      <p tabIndex={0}>
                        {this.state.currencySimbol + this.props.subsidy}
                      </p>
                    </div>
                  </div>
                )}
              {this.props.restaurantSelected &&
                this.props.restaurantSelected.forCollection === 'N' && (
                  <div className="subsidy">
                    <div className="left">
                      <p tabIndex={0}>Delivery Fee</p>
                    </div>
                    <div className="right">
                      <p tabIndex={0}>
                        {this.state.currencySimbol +
                          (this.getTaxDelivery() * orderCount).toFixed(2)}{' '}
                      </p>
                    </div>
                  </div>
                )}
              {!!this.props.campaignRateCollection &&
                this.props.restaurantSelected &&
                this.props.restaurantSelected.forCollection === 'Y' && (
                  <div className="collection-discount">
                    <div className="left">
                      <p tabIndex={0}>Collection discount</p>
                    </div>
                    <div className="right">
                      <p tabIndex={0}>
                        {this.props.campaignRateCollection.discountType === 'P'
                          ? '% '
                          : '- '}
                        {this.props.campaignRateCollection.amount}
                      </p>
                    </div>
                  </div>
                )}
              <div className="total">
                <div className="left">
                  <p tabIndex={0}>Total</p>
                </div>
                <div className="right" tabIndex={0}>
                  {cartTotalText(this.getTotal(), orderCount, this.state.currencySimbol)}
                </div>
              </div>
            </div>
            <div className="items">
              <div className="checked-cutlery">
                <input
                  onChange={evt => this.onHandleAddCutlery(evt)}
                  type="checkbox"
                  id="cutlery1"
                  name="cutlery"
                />
                <label htmlFor="cutlery1">
                  <b>Add Cutlery (Free)</b>
                </label>
              </div>
            </div>
            <div className="special-notes" tabIndex={0}>
              <div className="left">
                <p tabIndex={0}>Special notes</p>
              </div>
              <textarea
                value={this.state.specialNotes}
                onChange={this.handleSpecialNotes}
              />
              <p tabIndex={0}>
                Deliver @{' '}
                {this.getDeliverAddress() != null
                  ? this.getDeliverAddress().street
                  : null}
              </p>
              <p tabIndex={0}>
                or{' '}
                <a onClick={e => this.showOptionsForOrder()}>
                  <u>change here</u>
                </a>
              </p>
            </div>

            <DatePickerOrder
              restaurantSelected={this.props.restaurantSelected}
              handleTimeForOrder={this.handleTimeForOrder}
              timeForOrder={this.state.timeForOrder}
              deliveryTomorrow={this.props.deliveryTomorrow}
              onDeliveryTomorrow={this.onDeliveryTomorrow}
              ordersAhead={this.props.business && this.props.business.ordersAhead}
              isDeliverAtHome={this.isDeliverAtHome()}
            />
          </Aux>
        )}

        <OptionsForOrder
          onFetchingMenu={this.props.onFetchingMenu}
          idBusiness={this.props.userDetails.idBusiness}
          listAddress={this.props.listAddress}
          showModal={this.state.selectAddress}
          showCollectionOption={this.showCollectionOption()}
          showDeliverAtHomeOption={this.props.showDeliverAtHomeOption}
          selectOptionForOrder={this.handleSelectOptionForOrder}
          onToggleCart={this.props.onToggleCart}
          onDeleteAllproductsFromCard={this.props.onDeleteAllproductsFromCard}
          createCustomerDeliveryAddress={
            this.handleCreateCustomerDeliveryAddress
          }
          onCartResetState={this.props.onCartResetState}
          onDeleteRestaurantSelected={this.props.onDeleteRestaurantSelected}
          onFetchingRecentlyOrdered={this.props.onFetchingRecentlyOrdered}
        />

        <ModalError
          style={{ zIndex: '99999', position: 'absolute', margin: '5% 26%' }}
          showModal={!this.props.restaurantCurrentIsOpen}
          errorMessage={RESTAURANT_GONE_ERROR}
          actionButtonTitle="Reload the menu"
          actionButton={
            this.closeModalErrorAndClearLocalStorageRestaurantCurrentIsOpen
          }
        />

        <ModalCartMessage
          clickButtonConfirm={this.handleConfirmOkCartModal}
          clickButtonDeny={this.handleDenyCartModal}
          message={
            <strong>
              Note!
              <br />
              <br />
              Clear current basket to change address?
            </strong>
          }
          showModal={this.state.openModalClearBasket}
        />
        {empty ? null : (
          <Aux>
            <PaymentOptions
              payTypeSelected={this.state.payType}
              cardSelected={this.state.cardSelected}
              selectPaymentMethod={this.onHandleSelectPaymentMethod}
              total={this.props.total}
              subsidy={this.props.subsidy}
              business={this.props.business}
              cards={this.props.cards}
            />

            {this.state.placingOrder || this.state.sendingOrders ? (
              <Spinner nameClass={'lds-third'} label="Placing your order…" />
            ) : this.props.isLoading ? (
              <Spinner nameClass={'lds-secondary'} />
            ) : (
              <PaymentButton
                payTypeSelected={this.state.payType}
                campaignRateCC={this.props.campaignRateCC}
                handlePlaceOrder={this.handleDeliveryTomorrow}
                total={this.props.total}
              />
            )}
          </Aux>
        )}

        <AllergenGate
          check={this.state.allergenGate}
          busy={this.state.allergenBusy}
          error={this.state.allergenError}
          onAnswer={this.onAllergenAnswer}
          onConfirm={this.onAllergenConfirm}
          onClose={this.onAllergenClose}
        />

        {this.state.showDeliveryTomorrowConfirmationModal ? (
          <ModalConfirm
            title={'Confirm delivery for tomorrow'}
            onClose={this.handleDeliveryTomorrowCancel}
            onConfirm={this.handleDeliveryTomorrowConfirm}
          >
            <div>
              <h2 style={{ textTransform: 'none', fontSize: '20px' }}>
                Are you sure that you want your order delivery for tomorrow?
              </h2>
            </div>
          </ModalConfirm>
        ) : null}
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    subtotal: state.cartReducer.cart.subtotal,
    subsidy: state.cartReducer.cart.subsidy,
    tipValue: state.cartReducer.cart.tipValue,
    total: state.cartReducer.cart.total,
    isLoading: state.loadingReducer.loading,
    maxBasketCost: state.cartReducer.cart.maxBasketCost,
    productsOnCart: state.cartReducer.cart.products,
    productSelected: state.cartReducer.cart.productSelected,
    cards: state.cartReducer.cart.cards,
    restaurantCurrentIsOpen: state.cartReducer.cart.restaurantCurrentIsOpen,
    restaurantSelected: state.cartReducer.cart.restaurantSelected,
    business: state.businessReducer.business,
    addresses: state.menuReducer.addresses,
    listAddress: state.menuReducer.listAddress,
    showDeliverAtHomeOption: state.menuReducer.acceptDeliverAtHome,
    campaignRateCC: state.cartReducer.cart.campaignRateCC,
    campaignRateCollection: state.cartReducer.cart.campaignRateCollection,
    discounts: state.cartReducer.cart.discounts,
    deliveryTomorrow: state.cartReducer.cart.deliveryTomorrow,
    userDetails: state.authenticationReducer.userDetails,
    checkout: state.cartReducer.cart.checkout,
    guests: state.cartReducer.cart.guests || [],
    guestPolicy: state.cartReducer.cart.guestPolicy,
    partyValues: state.cartReducer.cart.partyValues,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // A problem found before anything is sent: {code, title, message, guidance}.
    triggerModalErrorPlacedOrder: problem =>
      dispatch(actions.triggerModalErrorPlacedOrder(problem.message, {
        preSubmitValidation: true,
        title: problem.title,
        guidance: problem.guidance,
        referenceCode: problem.code,
      })),
    onDeleteProductFromCart: product =>
      dispatch(actions.deleteProductFromCart(product)),
    onAddProductToCartNow: product =>
      dispatch(actions.addProductToCartNow(product)),
    onFetchGuestPolicy: () => dispatch(actions.fetchGuestPolicy()),
    onCalculatePartySubsidies: (
      idRestaurant,
      parties,
      taxDelivery,
      tipValue,
      withSubsidy
    ) =>
      dispatch(
        actions.calculatePartySubsidies(
          idRestaurant,
          parties,
          taxDelivery,
          tipValue,
          withSubsidy
        )
      ),
    onClearPartyValues: () => dispatch(actions.clearPartyValues()),
    onPlacePartyOrders: (sends, options) => dispatch(actions.placePartyOrders(sends, options)),
    onCalculateSubsidy: (idRestaurant, subTotal, taxDelivery, tipValue) =>
      dispatch(
        actions.calculateSubsidy(idRestaurant, subTotal, taxDelivery, tipValue)
      ),
    onAppliedCartValues: (
      subTotal,
      subsidy,
      total,
      maxBasketCost,
      discounts,
      tipValue
    ) =>
      dispatch(
        actions.appliedCartValues(
          subTotal,
          subsidy,
          total,
          maxBasketCost,
          discounts,
          tipValue
        )
      ),
    onFetchingMenu: (idBusiness, idAddress) =>
      dispatch(actions.fetchingMenu(idBusiness, idAddress)),
    onSelectForColectionOption: () =>
      dispatch(actions.changeRestaurantOptions(2)),
    onFetchingCampaignRate: idBusiness =>
      dispatch(actions.fetchingCampaignRate(idBusiness)),
    onPlaceOrder: (order, payInfo) =>
      dispatch(actions.placeOrder(order, payInfo)),
    onPlaceOrderAndPay: (order, payInfo) =>
      dispatch(actions.placeOrderAndPay(order, payInfo)),
    handlePlaceOrderAndGoToAddNewCard: (order, payInfo, history) =>
      dispatch(actions.placeOrderAndGoToAddNewCard(order, payInfo, history)),
    onToggleCart: status => dispatch(actions.toggleCart(status)),
    onToggleRestaurants: status => dispatch(actions.toggleRestaurants(status)),
    changeDeliveryTomorrow: payload =>
      dispatch(actions.changeDeliveryTomorrow(payload)),
    onSelectAddressForOrder: address =>
      dispatch(actions.selectAddressForOrder(address)),
    onCreateCustomerDeliveryAddress: place =>
      dispatch(actions.createCustomerDeliveryAddress(place)),
    onDeleteAllproductsFromCard: () =>
      dispatch(actions.deleteAllProductsFromCart()),
    onCartResetState: () => dispatch(actions.cartResetState()),
    onDeleteRestaurantSelected: () =>
      dispatch(actions.deleteRestaurantSelected()),
    onFetchingRecentlyOrdered: idAddress =>
      dispatch(actions.fetchingRecentlyOrdered(idAddress)),
    onCartSetRestaurantOpen: restaurantCurrentIsOpen =>
      dispatch(actions.cartSetRestaurantOpen(restaurantCurrentIsOpen)),
    closeModalError: history => dispatch(actions.closeModalError(history)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CartProduct)
);



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/CartProduct/index.js